import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { claimDetailBody, claimDetailHead, getClaimDetails } from './constants';
import { DrawerContext, useModal, claimStatusEnumsList } from 'utils';
import { DetailMessageBox, FullTable } from 'components';
import { claimActions, clientActions } from 'store';
import { ReceivableBillTable } from './core';

export const ClaimDetailsTab = ({ getAfterSuccess }) => {
    const claimDetails = useSelector((state) => state.claim.claimById);
    const filteredDetails = getClaimDetails(claimDetails);
    const { open: drawerOpen } = useContext(DrawerContext);
    const claimIsClosed = claimDetails?.status === claimStatusEnumsList.CLOSED;
    const { open } = useModal();
    const bills = claimDetails?.bills?.length ? claimDetails?.bills : [];
    const sortedList = bills?.sort((a, b) => new Date(a.dos) - new Date(b.dos));
    const dispatch = useDispatch();

    useEffect(() => {
        if (claimDetails?.clientId && claimDetails?.secondaryBilling) {
            dispatch(clientActions.getClientsEnrollment(claimDetails?.clientId, { type: 'SECONDARY', status: 'ACTIVE' }));
        }
    }, [claimDetails]);

    const afterSuccess = () => {
        dispatch(claimActions.getClaimById(claimDetails?.id, 'noLoad'));
    };

    function getDetailDisplay(detail) {
        if (detail && detail !== 'Undefined Undefined') {
            return detail;
        } else {
            return '--';
        }
    }

    return (
        <div>
            {claimIsClosed && <DetailMessageBox text={`Reason for closing: ${claimDetails?.details}`} />}

            <div className="details-wrapper">
                {!!filteredDetails.length && (
                    <ol className="details-list-box">
                        {filteredDetails.map(
                            (item, index) =>
                                item?.detail && (
                                    <li key={index} style={{ background: item?.background ? item?.background : '#F4F5F7' }}>
                                        <p className="detail-title-style"> {item.detailText}</p>
                                        <p className="detail-value-style">{getDetailDisplay(item.detail)}</p>
                                        {item?.customRow && item?.customRow}
                                    </li>
                                )
                        )}
                    </ol>
                )}
            </div>

            <div>
                <p className="details-title-box">Billing Entries</p>
                <FullTable
                    head={claimDetailHead(claimDetails)}
                    body={claimDetailBody(claimDetails, afterSuccess)}
                    list={sortedList}
                    handleClick={(e, item) => open(<ReceivableBillTable defaultBill={item} />)}
                    noText={'billing'}
                    activeRowId={''}
                    generateTable={true}
                    height={'auto'}
                />
            </div>
        </div>
    );
};
